export const NO_GROUP_ID = '%%NO_GROUP%%'
